import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-maskedinput';
import { connect } from 'react-redux';
import cx from 'classnames';
import {translate} from "react-i18next";

import Step from './Step';
import { editPassportClick } from '../../../Modal/SettingsModal/ProfileSettings/actions';
import FloatingLabelInput from '../../../common/FloatingLabelInput';
import FloatingLabelSelect from '../../../common/FloatingLabelSelect';
import FloatingLabelMaskedInput from '../../../common/FloatingLabelMaskedInput';

@translate(['register'], {wait:true})
class PassportStep extends Step {
  constructor(props) {
    super(props);

    this.state = {
      emitent: '',
      number: '',
      seria: '',
      issueDate: '',
      isNew: props.passportIsNew
    };
  }

  handleBackClick(e) {
    e.preventDefault();
    this.props.decreaseStepIndex()
  }

  handleNextClick(e) {
    e.preventDefault();
    this.props.increaseStepIndex()
    this.props.handleSaveClick(this.state);
  }

  handleSeriesAndNumber = (e) => {
    e.preventDefault();

    var series_and_number = e.target.value

    var regexp = /^(\d{2} \d{2}) (\d{6})$/;
    var match = regexp.exec(series_and_number);

    if (!regexp.test(series_and_number))
      return;

    var seria = match[1];
    var number = match[2];
    
    this.setState({ seria: seria, number: number });
  }

  render() {
    const {t} = this.props;

    return (
      <div className="container">
        <a onClick={this.handleBackClick} className="backStep" href=""></a>
        <form className="popupForm popupRegistrationForm" action="#">
          <div className="stepTitle">
            <h2>{t('register:passport')}</h2>
          </div>
          <div className="popupForm__body">
            <div className="row">
              <FloatingLabelMaskedInput mask="11 11 111111" placeholderChar={' '} placeholder={' '} type="text" label={t('register:series_and_number')} onChange={this.handleSeriesAndNumber}/>
            </div>
            <div className="row">
              <FloatingLabelMaskedInput
                mask="11.11.1111"
                placeholderChar={' '}
                type="text"
                label={t('register:issue_date')}
                onChange={e => {
                  e.preventDefault();
                  this.setState({issueDate: e.target.value});
                }}/>
            </div>
            <div className="row"><FloatingLabelInput type="text" label={t('register:emitent')} onChange={e => {
              e.preventDefault();
              this.setState({emitent: e.target.value});
            }}/></div>
          </div>
          <div className="rowButton">
            <button
            onClick={this.handleNextClick} className="btn"><span>{t('register:continue')}</span></button>
          </div>
        </form>
      </div>
    );
  }
}

PassportStep.propTypes = {
  handleSaveClick: PropTypes.func,
  errors: PropTypes.array,
};

export default connect(
  (state) => {
    return {
      errors: state.settings.passportErrors,
    };
  },
  (dispatch) => {
    return {
      handleSaveClick(passport) {
        return dispatch(editPassportClick({
          passport: {
            ...passport,
          },
        }));
      },
    };
  },
)(PassportStep);



// WEBPACK FOOTER //
// ./src/components/Auth/Registration/Steps/PassportStep.js